import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.3248 11.055C3.1996 10.8804 3.16629 10.656 3.23535 10.4525L4.26982 7.40353L2.60298 7.40353L1.86951 8.3962C1.74382 8.56631 1.54485 8.66669 1.33333 8.66669L0.666666 8.66669C0.436681 8.66669 0.222936 8.54815 0.101148 8.35306C-0.0206407 8.15796 -0.033275 7.91388 0.067723 7.70726L0.902223 6.00002L0.0677231 4.29278C-0.0332738 4.08616 -0.0206405 3.84208 0.101148 3.64698C0.222938 3.45189 0.436682 3.33335 0.666666 3.33335L1.33333 3.33335C1.54485 3.33335 1.74382 3.43373 1.86951 3.60384L2.60298 4.59651L4.26982 4.59651L3.23535 1.54755C3.16629 1.34402 3.1996 1.11968 3.3248 0.944994C3.45 0.770303 3.65174 0.666687 3.86667 0.666687L4.93333 0.666687C5.1543 0.666687 5.36091 0.776174 5.48498 0.959019L7.95328 4.59651L10.5333 4.59651C11.2915 4.59651 12 5.17355 12 6.00002C12 6.82649 11.2915 7.40353 10.5333 7.40353L7.95328 7.40353L5.48498 11.041C5.36091 11.2239 5.1543 11.3334 4.93333 11.3334L3.86667 11.3334C3.65174 11.3334 3.45 11.2297 3.3248 11.055Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}